module.exports = __webpack_public_path__ + "static/nord-macbook-ie-b920c59dd197b365c69aafb7df47d639.png";